import { TSortType } from '@/types.ts';

export const CUSTOMERS_DEFAULT_SORT: TSortType = {
    sort_by: 'created_date',
    sort_direction: 'desc',
};
